import { render, staticRenderFns } from "./AddBug.vue?vue&type=template&id=74788643&"
import script from "./AddBug.vue?vue&type=script&lang=ts&"
export * from "./AddBug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports